import { Grid } from '@mui/material'
import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect } from 'react'
import { Control, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import CONSTANTS, { PAGES_ROUTES, VALIDATIONS } from '../../../../Constants'
import { combineErrorMessage } from '../../../../Helpers/Util'
import { DownstreamPlatformsListResponse } from '../../../../Models'
import { useAppDispatch, useAppSelector } from '../../../../Store/Hooks'
import { showAlert } from '../../../../Store/Slice/alert.slice'
import {
  createDownstreamPlatformService,
  editDownstreamPlatformService,
  selectDownstreamPlatformData,
  setDownstreamPlatformsData,
} from '../../../../Store/Slice/downstreamPlatforms.slice'
import { MUIBox, MUIButton, MUIField, MUISelect } from '../../../Shared'
import styles from '../Masters.module.scss'

interface DownstreamPlatformsCreateEditFormPropsInterface {
  mastersPageType: string | undefined
}
const DOWNSTREAM_PLATFORM_CONTENTS = 'Downstream Platform'
const status: any = [
  { value: 'ACTIVE', label: 'Active', type: 'status-active' },
  { value: 'INACTIVE', label: 'In Active', type: 'status-inactive' },
]

const DownstreamPlatformsCreateEdit = ({
  mastersPageType,
}: DownstreamPlatformsCreateEditFormPropsInterface) => {
  const selectDownstreamPlatform = useAppSelector(selectDownstreamPlatformData)
  const selectedDownstreamPlatformData: DownstreamPlatformsListResponse | null =
    mastersPageType !== CONSTANTS.PAGE_TYPE.CREATE ? selectDownstreamPlatform : null
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm<any>({
    defaultValues: {
      id: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedDownstreamPlatformData?._id : '',
      status:
        mastersPageType === CONSTANTS.PAGE_TYPE.EDIT
          ? selectedDownstreamPlatformData?.status
          : 'ACTIVE',
      value:
        mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedDownstreamPlatformData?.value : '',
      key: mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedDownstreamPlatformData?.key : '',
    },
  })

  useEffect(() => {
    // Update form values when selectedDownstreamPlatformData changes
    setValue(
      'id',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedDownstreamPlatformData?._id : '',
    )
    setValue(
      'status',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT
        ? selectedDownstreamPlatformData?.status
        : 'ACTIVE',
    )
    setValue(
      'value',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedDownstreamPlatformData?.value : '',
    )
    setValue(
      'key',
      mastersPageType === CONSTANTS.PAGE_TYPE.EDIT ? selectedDownstreamPlatformData?.key : '',
    )
  }, [selectedDownstreamPlatformData, mastersPageType, setValue])

  const createDownstreamPlatform = async (data: any) => {
    const reqData: any = {
      ...data,
    }
    const result = await dispatch(createDownstreamPlatformService(reqData) as any)
    return result
  }

  const editDownstreamPlatform = async (data: any) => {
    const reqData: any = {
      ...data,
    }
    const result = await dispatch(editDownstreamPlatformService(reqData) as any)
    return result
  }

  const onSubmit = async (data: any) => {
    let result: any
    if (selectedDownstreamPlatformData?._id && mastersPageType === CONSTANTS.PAGE_TYPE.EDIT) {
      result = await editDownstreamPlatform(data)
    }
    if (mastersPageType === CONSTANTS.PAGE_TYPE.CREATE) {
      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        delete data?.id
      }
      result = await createDownstreamPlatform(data)
    }
    const unWrapRes = unwrapResult(result)
    if (unWrapRes?.error) {
      dispatch(showAlert([true, combineErrorMessage(unWrapRes), 'error']))
      return
    }
    dispatch(showAlert([true, unWrapRes.message, 'success']))
    dispatch(setDownstreamPlatformsData(null))
    navigate(
      `/${PAGES_ROUTES.MetaMaster}/${PAGES_ROUTES.Masters}/${PAGES_ROUTES.DownstreamPlatforms}`,
    )
  }

  return (
    <MUIBox>
      <div>
        <div className={`heading-6 d-flex text-left ${styles.masters__box__header__padding}`}>
          {DOWNSTREAM_PLATFORM_CONTENTS}
        </div>
        <div className={styles.hr}></div>
        <div className={styles.mastersbox__content_padding}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container columnSpacing={10} rowSpacing={4}>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUIField
                  name='key'
                  label='Key'
                  required
                  type='text'
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  maxLength={100}
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUIField
                  name='value'
                  label='Value'
                  required
                  type='text'
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  maxLength={100}
                />
              </Grid>
              <Grid item xs={6} md={6} lg={6} xl={6}>
                <MUISelect
                  name='status'
                  lable={'Status'}
                  required
                  rules={{ required: VALIDATIONS.REQUIRED }}
                  control={control as Control | undefined}
                  error={errors}
                  options={status}
                />
              </Grid>
              <Grid xs={12} item>
                <Grid container spacing={10}>
                  <Grid item xs={6}></Grid>

                  <Grid item xs={6} className='d-flex justify-content-end'>
                    <MUIButton
                      disabled={!isValid}
                      size='large'
                      type={'submit'}
                      label={'Submit'}
                      variant='contained'
                      width={200}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
    </MUIBox>
  )
}

export default React.memo(DownstreamPlatformsCreateEdit)
